import React from "react";
import Chart from "react-apexcharts";

type StackedChartProps = {
  data: ApexAxisChartSeries;
  categories: string[];
};

export const StackedChart = (props: StackedChartProps) => {
  const { data, categories } = props;
  const options = {
    chart: {
      stacked: true,
    },
    xaxis: {
      categories,
    },
    tooltip: {
      intersect: false,
      shared: true,
    },
  };
  return <Chart series={data} options={options} type="bar" height="300px" />;
};
